<div class="event-card" [ngStyle]="{
    'width.px': width,
    'height.px': height,
    'background-image': 'url(' + imageSrc + ')'
  }"
  (click)="onClick($event)">
</div>

<!-- Полноэкранное изображение (переносится в body — см. overlay в компоненте) -->
<div class="fullscreen-overlay" #overlay *ngIf="showImage && imageSrc" (click)="onClose($event)">
    <img [src]="imageSrc" class="fullscreen-image">
    <button class="close-button" (click)="onClose($event)">✖</button>
</div>